import React from 'react'
import Label from './Label'
import ErrorMessage from './ErrorMessage'
import { useFieldsLocked } from '../../contexts/ReadOnlyContext'

export default function Input({
  addon,
  addonPosition = 'start',
  autoFocus,
  error,
  forceLight = false,
  label,
  max,
  min,
  name,
  noRightPadding,
  noLabelPadding,
  noGreenBorder,
  inputPaddingClass,
  onBlur,
  onChange = () => {},
  optional,
  placeholder,
  type,
  value = undefined,
  defaultValue= undefined,
  className,
  overrideClassName = '',
  topMargin = 'mt-5',
  disabled: disabledProp,
  maxLength,
  autoComplete,
  setInitialValue = () => {},
  onAddonClick = null,
  addonColor = 'text-gray-500'
}) {
  const fieldsLocked = useFieldsLocked()
  const disabled = disabledProp || fieldsLocked
  const controlThemeClasses = forceLight
    ? 'border-rb-lite-grey bg-white'
    : 'border-rb-lite-grey dark:border-rb-dark-mode-lighter bg-white dark:bg-rb-dark-mode'
  const inputThemeClasses = forceLight
    ? '[color-scheme:light] text-rb-black placeholder-rb-mat-grey'
    : '[color-scheme:light] dark:[color-scheme:dark] text-rb-black dark:text-rb-dark-mode-text-light placeholder-rb-mat-grey dark:placeholder-rb-dark-mode-text-grey'
  const paddingClasses = inputPaddingClass || `${addonPosition === 'start' ? 'pl-1' : 'pl-4'} ${addonPosition === 'end' ? 'pr-2' : 'pr-4'}`

  return (
    <div className={topMargin}>
      <Label label={label} forceLight={forceLight} noRightPadding={noRightPadding} noLabelPadding={noLabelPadding}/>

      <div className={`
        flex items-center
        rounded-lg overflow-hidden
        border-1 ${controlThemeClasses}
        ${noGreenBorder ? '' : 'focus-within:border-rb-green focus-within:border-2'}
        ${error ? 'border-red-500' : ''}
        ${disabled ? 'rb-disabled' : ''}
      `}>
        {addon && addonPosition === 'start' && (
          <span
            className={`ml-1 pr-1 ${addonColor} select-none leading-none ${onAddonClick ? 'cursor-pointer' : ''}`}
            onClick={onAddonClick}
            style={{paddingTop: '1px'}}
          >
            {addon}
          </span>
        )}

        <input
          autoFocus={autoFocus}
          className={`
            ${className ? className : 'px-4'}
            h-11 w-full
            bg-transparent
            ${inputThemeClasses}
            focus-visible:outline-0
            focus:outline-0
            focus:ring-transparent
            focus:ring-offset-transparent
            ring-transparent
            ring-offset-transparent
            border-0
            leading-none
            ${type === 'date' ? 'rb-date-input' : ''}
            ${overrideClassName}
            ${paddingClasses}
          `}
          max={max}
          min={min}
          name={name}
          onBlur={onBlur}
          onChange={e => {
            setInitialValue(e)
            return onChange(e)
          }}
          placeholder={placeholder}
          type={type}
          value={value}
          defaultValue={defaultValue}
          disabled={disabled}
          maxLength={maxLength}
          autoComplete={autoComplete}
        />

        {addon && addonPosition === 'end' && (
          <span
            className={`mr-2 pl-2 ${addonColor} select-none leading-none ${onAddonClick ? 'cursor-pointer' : ''}`}
            style={{paddingTop: '1px'}}
            onClick={onAddonClick}
          >
            {addon}
          </span>
        )}

        {optional && <p className="optional-text">Optional</p>}
      </div>
      {
        error && (
          <ErrorMessage text={error} />
        )
      }
    </div>
  )
}
